var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "32px",
    viewBox: "0 0 31 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-443.000000, -276.000000)",
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(111.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.800000, 0.450000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Communication-/-textsms",
    transform: "translate(57.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 35.7 0 35.7 36.75 0 36.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75,3.0625 L5.95,3.0625 C4.31375,3.0625 2.975,4.440625 2.975,6.125 L2.975,33.6875 L8.925,27.5625 L29.75,27.5625 C31.38625,27.5625 32.725,26.184375 32.725,24.5 L32.725,6.125 C32.725,4.440625 31.38625,3.0625 29.75,3.0625 Z M29.75,24.5 L8.925,24.5 L5.95,27.5625 L5.95,6.125 L29.75,6.125 L29.75,24.5 Z M10.4125,13.78125 L13.3875,13.78125 L13.3875,16.84375 L10.4125,16.84375 L10.4125,13.78125 Z M16.3625,13.78125 L19.3375,13.78125 L19.3375,16.84375 L16.3625,16.84375 L16.3625,13.78125 Z M22.3125,13.78125 L25.2875,13.78125 L25.2875,16.84375 L22.3125,16.84375 L22.3125,13.78125 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat.44365d6c.svg";
export { ForwardRef as ReactComponent };